import { connect } from "react-redux";
import { refreshSet } from "../actions";

const mapDispatchToProps = (dispatch) => ({
  setRefresh: (data) => {
    dispatch(refreshSet(data));
  },
});

const mapStateToProps = (state) => ({
  refresh: state.refresh,
});

export default connect(mapStateToProps, mapDispatchToProps);
